(() => {
  const payload = Object.freeze({"signature": "nciujz-fy", "family": "rysesupps"});

  function applySignature() {
    document.documentElement.setAttribute("data-codex-code-runtime", payload.signature);
    document.documentElement.setAttribute("data-codex-code-runtime-family", payload.family);
    document.documentElement.style.setProperty("--codex-code-runtime-token", "727");
    document.documentElement.style.setProperty("--codex-code-runtime-family-token", "200");
    window.__CODEX_THEME_SIGNATURE__ = payload;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applySignature, { once: true });
  } else {
    applySignature();
  }
})();
